angular.module('ngApp')
.controller('signupPageController', ['$scope', '$state', function ($scope, $state) {
  if ($scope.user) {
    $state.go('index')
  }
}])
